export class ExampleDetail {
  id?: string;
  uuid?: string;
  parentId?: string;
  detailInput?: string;
  detailCalendar?: string;
  detailDropdown?: string;
  detailAutoCompleteCode?: string;
  detailAutoCompleteName?: string;
  detailAutoCompleteNameTw?: string;
  detailAutoCompleteNameCn?: string;
  detailAutoCompleteNameUs?: string;
  detailAutoCompleteFilter?: string;
  detailInputNumber?: number;
  detailCalendarRange?: string[];
  detailCustValidation?: string;
  detailDynamicDropdown?: string;
  detailAutoCompleteDropdownCode?: string;
  detailAutoCompleteDropdownName?: string;
  detailAutoCompleteDropdownNameTw?: string;
  detailAutoCompleteDropdownNameCn?: string;
  detailAutoCompleteDropdownNameUs?: string;
  detailAutoCompleteDropdownFilter?: string;

  setDetailAutoCompleteFilter(): void {
    this.detailAutoCompleteFilter = (this.detailAutoCompleteCode ? this.detailAutoCompleteCode + ' ' : '')
      + (this.detailAutoCompleteNameTw ? this.detailAutoCompleteNameTw + ' ' : '')
      + (this.detailAutoCompleteNameCn ? this.detailAutoCompleteNameCn + ' ' : '')
      + (this.detailAutoCompleteNameUs ? this.detailAutoCompleteNameUs : '')
  }

  setDetailAutoCompleteDropdownFilter(): void {
    this.detailAutoCompleteDropdownFilter = (this.detailAutoCompleteDropdownCode ? this.detailAutoCompleteDropdownCode + ' ' : '')
      + (this.detailAutoCompleteDropdownNameTw ? this.detailAutoCompleteDropdownNameTw + ' ' : '')
      + (this.detailAutoCompleteDropdownNameCn ? this.detailAutoCompleteDropdownNameCn + ' ' : '')
      + (this.detailAutoCompleteDropdownNameUs ? this.detailAutoCompleteDropdownNameUs : '')
  }
}
